import store from '@/store/store';

export const canAccess = async (params = {}) => {
  const slug = params.name.split('.');
  let action = '';
  let route = '';

  if (slug.length === 1) {
    action = 'View';
    route = slug[0];
  } else {
    const actionSlug = slug[slug.length - 1];
    action = actionSlug[0].toUpperCase() + actionSlug.substring(1);
    slug.pop();
    route = slug.join('_')
  }

  if (route.includes('personas')) {
    return store.getters['personas/isSystem'];
  }

  const privileges = store.getters['personas/privileges'];
  const hasAccess = privileges.find((navAccessItem) => navAccessItem.PageName === route);

  return (hasAccess && hasAccess[action] && Number(hasAccess[action]));
}
